import { useCallback, useEffect } from 'react';
import { apiClient } from '@/api/client';
import { useNetworkStatus } from '@/mobile/hooks/useNetworkStatus';
import {
  flushOfflineQueue,
  type OfflineQueueItem,
} from '@/mobile/services/offlineQueue.service';
import { MobileApiService } from '@/services/mobileApiService';
import { getLastRegisteredDeviceId } from '@/mobile/services/push.service';

async function sendQueuedItem(item: OfflineQueueItem): Promise<void> {
  await apiClient.request({
    method: item.method,
    url: item.url,
    data: item.body,
    headers: item.headers,
  });
}

export function useOfflineFlush() {
  const { connected } = useNetworkStatus();

  const flush = useCallback(async () => {
    const result = await flushOfflineQueue(sendQueuedItem);
    if (result.flushed.length) {
      try {
        await MobileApiService.ackSync(
          result.flushed,
          getLastRegisteredDeviceId() || undefined,
        );
      } catch {
        // Ack is best-effort
      }
    }
    return result;
  }, []);

  useEffect(() => {
    if (connected) void flush();
  }, [connected, flush]);

  return { flush };
}
